<template>
  <div class="country-select">
    <div class="country-container">
      <div class="country-language-title">
        Language
      </div>
      <div>
        <CustomSelect
          v-model="language"
          :options="languageList"
          @update-model-value="handleLanguageChange"
        />
      </div>
      <div class="country-language-title country-Currency-title">
        Currency
      </div>
      <div>
        <CustomSelect
          v-model="selectedValue"
          :options="currencyList"
          @update-model-value="emitFn"
        />
      </div>
      <div
        class="country-confirm"
        @click="saveCurrency"
      >
        Save
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted, ref, watch } from 'vue'
import CustomSelect from '@/components/CustomSelect/index.vue'
import { useStore } from 'vuex'

const selectedValue = ref('')
const language = ref('English')
const languageList = ref(['English', 'others'])
const currencyData = ref({})

const store = useStore()

const currency = computed(() => store.getters.getCurrencyList).value

const currencyList = computed(() => {
  const list = store.getters.getCurrencyList

  const res = []
  list.forEach(v => {
    const str = `${v.targetCurrency} (${v.targetCurrency.slice(0, 2)} ${v.targetUnit})`
    res.push(str)
  })

  return res
})

if (localStorage.getItem('currencyData')) {
  const data = JSON.parse(localStorage.getItem('currencyData'))
  selectedValue.value = `${data?.targetCurrency} (${data?.targetCurrency.slice(0, 2)} ${data?.targetUnit})`
  currencyData.value = data
} else {
  selectedValue.value = `${currency[0]?.targetCurrency} (${currency[0]?.targetCurrency.slice(0, 2)} ${currency[0]?.targetUnit})`
  currencyData.value = currency[0]
}

// 切换语种
const handleLanguageChange = (val) => {
  if (val === 'others') {
    window.open(
      'https://chromewebstore.google.com/detail/google-translate/aapbdbdomjkkjkaonfhkkikfgjllcleb',
      '_blank'
    )
  }
}

const emitFn = (e) => {
  const str = e.split(' ')[0]
  const data = currency.filter((v) => v.targetCurrency.includes(str))[0]
  currencyData.value = data
}

const saveCurrency = (event) => {
  localStorage.setItem('currencyData', JSON.stringify(currencyData.value))
  store.commit('setCurrencyData', currencyData.value)
  store.dispatch('setProduct', currencyData.value)
}
</script>

<style scoped lang="less">
.country-select {
  // width: 180px;
  background-color: #ffffff;
  .country-container {
    .country-language-title {
      font-family: mon-600;
      font-size: 12px;
      color: #232323;
      line-height: 16px;
      letter-spacing: -2%;
    }
    .country-Currency-title {
      margin-top: 16px;
    }
  }
  .country-item {
    width: 120px;
    background-color: #ffffff;
  }
  .exchange-rate {
    font-size: 11px;
    line-height: 14px;
    letter-spacing: -2%;
    font-family: mon-600;
    color: #232323;
    margin-top: 12px;
    .exchange-rate-unit {
      display: inline-block;
    }
    .exchange-rate-current {
      color: #052784;
    }
  }
  .exchange-desc {
    font-size: 9px;
    font-family: mon-400;
    line-height: 14px;
    letter-spacing: -2%;
    color: #6e717a;
  }
  .country-confirm {
    width: 100%;
    height: 32px;
    margin-top: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: mon-600;
    font-size: 12px;
    letter-spacing: -2%;
    text-align: center;
    line-height: 24px;
    color: #ffffff;
    background-color: rgba(5, 29, 132, 1);
    border-radius: 16px;
    cursor: pointer;
    transition: all 0.3s;
  }
  .country-confirm:hover {
    background-color: rgba(5, 29, 132, 0.9);
  }
  .country-confirm:active {
    background-color: rgba(5, 29, 132, 0.8);
    transform: scale(0.9);
  }
}
</style>
